module.exports = __webpack_public_path__ + "img/verbier-careers-summer.f181651.jpg";